import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import * as React from "react";
import {
  Datagrid,
  downloadCSV,
  List,
  TextField,
  useGetOne,
  useRecordContext,
  useRefresh,
} from "react-admin"; // eslint-disable-line import/no-unresolved
import useNotify from "../unit/useNotify";

import { CloseOutlined } from "@mui/icons-material";
import PartnersListActions from "../partners/PartnersListActions";
import PartnersListAside from "../partners/PartnersListAside";
import { hmLightTheme } from "../themes/hmTheme";
import PostPagination from "../unit/PostPagination";

import { RaRecord } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonCancel from "../unit/CustomButtonCancel";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import CustomEditIcon from "../unit/CustomEditIcon";
import CustomEditLinkProductIcon from "../unit/CustomEditLinkProductIcon";
import CustomEditRemoveIcon from "../unit/CustomEditRemoveIcon";
import CustomEditTermIcon from "../unit/CustomEditTermIcon";
import CustomLoading from "../unit/CustomLoading";
import CustomUniqueURLIcon from "../unit/CustomUniqueURLIcon";
import CounselorsAdd from "./CounselorsAdd";
import CounselorsEdit from "./CounselorsEdit";
import SwitchIcon from "../unit/svgIcon/SwitchIcon";
import SwitchOnIcon from "../unit/svgIcon/SwitchOnIcon";
import CustomAgencyIcon from "../unit/CustomAgencyIcon";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
import CustomFilterButton from "../unit/CustomFilterButton";
import NoPermission from "../unit/NoPermission";
import getCounselorsListFilters from "./CounselorsListFilters";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import CustomNoResults from "../unit/CustomNoResults";
const counselorTypeExporter = (records: any) => {
  let data = [];
  let title = {};
  data = records.map((record: any) => {
    return {
      id: record.id,
      sName: record.sName,
      sCity: record.sCity,
      sState: record.sState,
      sAgencyAdminName: record.sAgencyAdminName,
      sAgencyAdminEmail: record.sAgencyAdminEmail,
      productNum: record.productNum,
      sStatus: record.sStatus == 1 ? "Active" : "Inactive",
    };
  });
  title = {
    id: "Agency #",
    sName: "Organization",
    sCity: "City",
    sState: "State",
    sAgencyAdminName: "Agency Admin Name",
    sAgencyAdminEmail: "Agency Admin Email",
    productNum: "Products Linked",
    sStatus: "Status",
  };
  return {
    title: title,
    data: data,
  };
};

const CustomExporter = (records: any) => {
  const filterData = counselorTypeExporter(records);

  let csvTitle = filterData.title;
  let data = filterData.data;
  const currentFilters = getFiltersFromURL();
  const filterString = Object.entries(currentFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        return `[${getFieldTitle(key)} ${getFieldValueType(
          key
        )} "${getFieldValue(key, value)}"]`;
      }

      return "";
    })
    .filter(Boolean)
    .join("");
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));

  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }

  downloadCSV(csvDataStr.join("\n"), "Counselors");
};

function getFieldTitle(field: string) {
  const titleMap: Record<string, string> = {
    id: "Agency #",
    sName: "Organization",
    sCity: "City",
    sState: "State",
    sAgencyAdminName: "Agency Admin Name",
    sAgencyAdminEmail: "Agency Admin Email",
  };

  return titleMap[field] || field;
}

function getFieldValueType(field: string) {
  const typeMap: Record<string, string> = {
    id: "contains",
    sName: "contains",
    sCity: "contains",
    sState: "contains",
    sAgencyAdminName: "contains",
    sAgencyAdminEmail: "contains",
  };

  return typeMap[field] || "is";
}

function getFieldValue(field: string, value: any) {
  return value;
}

const CustomProductNameField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  let productNameArray = record?.sProductName;

  let productNums = 0;
  if (productNameArray) {
    Object.keys(productNameArray).map((key) => {
      productNums++;
    });
  }

  return <Typography>{productNums}</Typography>;
};
const CustomStatusField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  let status = record?.sStatus;
  if (record.sStatus == "1") {
    status = "Active";
  } else if (record.sStatus == "0") {
    status = "Inactive";
  }
  return <Typography>{status}</Typography>;
};
const CustomCounselorNameField = ({ ...props }) => {
  let record = useRecordContext();
  if (!record) return null;
  return record?.sName;
};
interface RecordType {
  id: string;
  title: string;
  body: string;
}

interface CustomButtonProps {
  onClick: (record: RaRecord) => void;
  source?: string;
  label?: string;
  sortable?: boolean;
}

const CounselorsList = () => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [selectedRecord, setSelectedRecord] = React.useState<RaRecord | null>(
    null
  );
  const [open, setOpen] = React.useState(false);
  const [productList, setProductList] = React.useState([]);
  const [counselorList, setCounselorList] = React.useState<[]>([]);
  const [currentTab, setCurrentTab] = React.useState("info");
  const [record, setRecord] = React.useState<{ total: number } | null>(null);
  const refresh = useRefresh();
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_partners")) {
    return <NoPermission />;
  }
  const { data, isLoading, error } = useGetOne("total/partner", { id: 1 });
  React.useEffect(() => {
    setRecord(data);
  }, [data]);
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const [products, counselors] = await Promise.all([
          sendRequest("products/shortList", { id: 0 }),
          sendRequest("counselors/shortList", { id: 0 }),
        ]);
        setProductList(products);
        setCounselorList(counselors);
      } catch (err) {
        errorNotify(`Error loading data`);
      }
    };
    fetchData();
  }, []);
  if (error) {
    errorNotify("Error loading data " + error);
  }
  if (isLoading) {
    return <HmLoading />;
  }
  const total = record ? record.total : 0;

  const handleRowClick = (
    id: any,
    resource: string,
    record: RaRecord,
    event: React.MouseEvent,
    basePath: string
  ) => {
    setSelectedRecord(record);
    event.stopPropagation();
  };
  const handleCancel = () => {
    setSelectedRecord(null);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedRecord(null);
    if (currentTab == "linkProducts") {
    }
  };

  const CustomButton = ({ onClick }: CustomButtonProps) => {
    const record = useRecordContext();
    if (!record) return null;

    const handleClick = (showTab: string) => {
      onClick(record);
      setOpen(true);
      setCurrentTab(showTab);
    };
    const handleChangeStatus = () => {
      let newStatus = record.sStatus == 1 ? 0 : 1;

      var reqUrl = "counselors/actions/changeStatus";
      var response = sendRequest(reqUrl, {
        id: record.id,
        data: {
          status: newStatus,
        },
      });
      response
        .then((res) => {
          if (res.code == 200) {
            successNotify("Status changed successfully");
            refresh();
          } else {
            errorNotify("Failed to change status! " + res.message);
          }
        })
        .catch((error) => {
          errorNotify("Error changing status: " + error.message);
        });
    };
    const handleRemove = () => {};
    return (
      <>
        <CustomAgencyIcon
          onClick={() => handleClick("agency")}
          label="Agency"
        />

        <CustomEditLinkProductIcon
          onClick={() => handleClick("linkProducts")}
          label="Link products"
        />

        <CustomUniqueURLIcon
          onClick={() => handleClick("uniqueURL")}
          label="Unique URL"
        />
        <CustomEditRemoveIcon onClick={handleChangeStatus} label="Remove" />
      </>
    );
  };

  const handleButtonClick = (record: RaRecord) => {
    setOpen(true);
    setSelectedRecord(record);
  };
  const CustomRowStyle = (record: any) => {
    if (!record) return {};

    if (record?.sStatus == "1" || record?.sStatus == 1) {
      return {
        backgroundColor: "#fff",
        "&.MuiTableRow-hover:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      };
    } else {
      return {
        backgroundColor: "#f5f5f5",
        "& td.MuiTableCell-root": {
          color: "gray",
        },
        "& td.MuiTableCell-root span": {
          color: "gray",
        },
        "& td.MuiTableCell-root a": {
          color: "gray",
        },
        "& td.MuiTableCell-root p": {
          color: "gray",
        },
      };
    }
  };
  const authrole = localStorage.getItem("authrole");
  return (
    <>
      <List
        actions={
          <PartnersListActions
            selected="counselors"
            productList={productList}
            counselorList={counselorList}
          />
        }
        filters={getCounselorsListFilters()}
        aside={<PartnersListAside totalData={total} selected="counselors" />}
        exporter={CustomExporter}
        empty={false}
        emptyWhileLoading={false}
        loading={<HmLoading />}
        sort={{ field: "created_at", order: "DESC" }}
        sx={{
          width: "100%",
          borderRadius: "0px",
          wordBreak: "break-word",
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        pagination={<PostPagination />}
        perPage={25}
      >
        <Datagrid
          optimized
          rowClick={false}
          empty={false}
          rowSx={CustomRowStyle}
          size="small"
          id="table-counselors"
          className="hm-list-datagrid"
          sx={{
            ".MuiTableCell-root": {
              padding: "6px",
            },
            ".RaDatagrid-headerCell:first-child": {
              borderTopLeftRadius: "0px",
            },
            ".RaDatagrid-headerCell:last-child": {
              borderTopRightRadius: "0px",
            },
            overflowY: "auto",
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" },
            },
            "& .Mui-active": {
              color: "gray",
            },
            "& .MuiTableSortLabel-root": {
              padding: "5px",
            },
            "& .RaDatagrid-headerCell": {
              color: "gray",
              fontSize: "1rem",
              backgroundColor: "#edf4fb",
              wordWrap: "break-word",
            },
            "& .MuiTableCell-paddingCheckbox": {
              display: "none",
            },
            "& .MuiTableCell-root.column-sContactor": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-sAgencyAdminName": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-sAgencyAdminEmail": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordBreak: "break-word",
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "normal",
            },
            "& .MuiTableCell-root.column-sEmail": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
              textAlign: "left",
              wordWrap: "break-word",
            },
            "& .MuiTableCell-root.column-id": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              color: "red",
            },
            "& .MuiTableCell-root.column-sCity": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            },
            "& .MuiTableCell-root.column-sState": {
              minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              width: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
              maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdMiddleWidth,
            },
          }}
        >
          <TextField source="id" label="Agency #" cellClassName="numericText" />
          <CustomCounselorNameField source="sName" label="Organization" />
          <TextField source="sCity" label="City" />
          <TextField source="sState" label="State" />
          {/* <TextField
                source="sContactor"
                label="Contact Name"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
              />
              <TextField
                source="sContactEmail"
                label="Contact Email"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
              />
              <TextField
                source="sContactPhone"
                label="Contact Phone"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
              /> */}
          <TextField
            source="sAgencyAdminName"
            label="Agency Admin Name"
            sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
          />
          <TextField
            source="sAgencyAdminEmail"
            label="Agency Admin Email"
            sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
          />
          {/* <TextField
                source="sAddress"
                label="Address"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
              />
              <TextField
                source="sAddress2"
                label="Address2"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
              /> */}

          {/* <TextField
                source="sZip"
                label="Zip"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
              /> */}
          {/* <CustomProductNameField
                source="sProductName"
                label="Products Linked"
                sx={{ fontFamily: hmLightTheme?.palette?.numberFontFamily }}
                //disable order
                sortable={false}
              /> */}
          <TextField
            source="productNum"
            label="Products Linked"
            cellClassName="numericText"
          />

          {authrole != "admin" && (
            <CustomButton
              source="column-action"
              onClick={handleButtonClick}
              label="Action"
              sortable={false}
            />
          )}
        </Datagrid>
        <CustomLoading />
      </List>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            let form = document.querySelector(
              ".counselors_edit_dialog_form form"
            );
            let formData = new FormData(form as HTMLFormElement);
            let formJson = Object.fromEntries(formData.entries());
            let select_products: any[] = [];
            let select = document.querySelectorAll(
              ".counselors_edit_dialog_form .partners_select_product"
            );
            select.forEach((element) => {
              if ((element as HTMLInputElement)?.checked) {
                select_products.push((element as HTMLInputElement)?.value);
              }
            });
            formJson.productId = select_products.join(",");
            // console.log("counselors formJson===>", formJson);

            const reqUrl = `counselors/actions/edit`;
            const response = await sendRequest(reqUrl, {
              id: selectedRecord?.id,
              data: formJson,
            });
            if (response && response.code == "200") {
              successNotify("Data saved successfully");
              refresh();
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          {/* Counselor Edit Record #{selectedRecord?.id} */}
          {currentTab == "agency" && "Agency"}
          {currentTab == "info" && "Edit info"}
          {currentTab == "linkProducts" && "Link Products"}
          {currentTab == "special" && "Set Terms"}
          {currentTab == "uniqueURL" && "Unique URL"}
          {currentTab == "remove" && "Remove"}
          <IconButton
            style={{ position: "absolute", right: "10px", top: "10px" }}
            onClick={handleClose}
          >
            <CloseOutlined />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              width: "100%",
              pt: 1,
              height: "50vh",
              maxHeight: "50vh",
            }}
          >
            {selectedRecord && (
              <CounselorsEdit
                id={selectedRecord.id}
                basePath="/counselors"
                resource="counselors"
                productList={productList}
                curTab={currentTab}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {currentTab == "linkProducts" && <CustomButtonSubmit label="Save" />}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CounselorsList;
